(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moco-product"]) return;
  try {
    
(function(){
function init(){
var form=document.getElementById('MocoProductForm');if(!form)return;
var variant=form.querySelector('#m-variant'),selectors=[].slice.call(form.querySelectorAll('.m-v18-option-select'));
/* Presentation order only: Shopify's underlying option indices and variant mapping stay unchanged. */
var optionGroup=form.querySelector('.m-v18-options');
if(optionGroup){
 var groups=[].slice.call(optionGroup.querySelectorAll('.m-v18-option'));
 function optionRank(group){
  var label=(group.querySelector('label')?.textContent||'').trim().toLowerCase();
  if(/garment|apparel|product type|style|shirt type|item type|clothing type/.test(label))return 0;
  if(/colou?r/.test(label))return 1;
  if(/size|sizing/.test(label))return 2;
  return 3;
 }
 groups.map(function(el,i){return {el:el,i:i,rank:optionRank(el)}})
  .sort(function(a,b){return a.rank-b.rank||a.i-b.i})
  .forEach(function(item){optionGroup.appendChild(item.el)});
}

var button=document.getElementById('m-add-button'),price=document.getElementById('m-product-price'),image=document.getElementById('m-product-image'),message=document.getElementById('m-v18-option-message');
var variants=[].slice.call(variant.options).map(function(o){return {el:o,options:(o.dataset.options||'').split('||')}});
function chooseColorImage(color){
 if(!image||!color)return;
 var normalized=function(s){return (s||'').toLowerCase().replace(/[^a-z0-9]/g,'')};
 var colorKey=normalized(color);
 var thumbs=[].slice.call(document.querySelectorAll('.m-image-choice'));
 var match=thumbs.find(function(t){
   var alt=t.dataset.imageAlt||'';
   var tagged=alt.match(/(?:^|\\s)COLOR\\s*:\\s*([^|;,]+)/i);
   return tagged&&normalized(tagged[1])===colorKey;
 });
 if(!match)match=thumbs.find(function(t){
   var file=(t.dataset.imageFilename||'').toLowerCase().replace(/\\.[^.]+$/,'');
   return file.split(/[-_\\s]+/).join('').indexOf(colorKey)!==-1;
 });
 if(!match)return;
 image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=match.dataset.image;
 thumbs.forEach(function(t){t.classList.toggle('is-active',t===match);t.setAttribute('aria-pressed',t===match?'true':'false')});
}
function showVariant(opt){
 if(!opt)return;
 variant.value=opt.value;
 button.disabled=opt.dataset.available!=='true';
 button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;
 price.textContent=opt.dataset.price;
 /* All product images now come from Shopify product media, not theme assets.
    Prefer an image with alt text COLOR: Purple or a color token in its filename. */
 var colorSelector=selectors.find(function(sel){return /colou?r/i.test(sel.previousElementSibling?.textContent||'')});
 if(colorSelector)chooseColorImage(colorSelector.value);
 var url=new URL(location.href);url.searchParams.set('variant',opt.value);history.replaceState(null,'',url);
}
function update(){
 var wanted=selectors.map(function(el){return el.value});
 var found=variants.find(function(v){return v.options.length===wanted.length&&v.options.every(function(o,i){return o===wanted[i]})});
 if(!found){variant.value='';button.disabled=true;button.textContent='Unavailable combination';message.textContent='This combination is not offered. Please choose another option.';return}
 message.textContent=found.el.dataset.available==='true'?'':'This combination is currently sold out.';
 showVariant(found.el);
}
selectors.forEach(function(sel){sel.addEventListener('change',update)});
variant.addEventListener('change',function(){var found=variants.find(function(v){return v.el.value===variant.value});if(found){selectors.forEach(function(sel,i){sel.value=found.options[i]});showVariant(found.el)}});
document.addEventListener('click',function(event){var thumb=event.target.closest('.m-image-choice');if(!thumb)return;if(image){image.removeAttribute('srcset');image.src=thumb.dataset.image}});
if(selectors.length)update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moco-schools"]) return;
  try {
    document.addEventListener("input",function(event){if(event.target.id!=="school-filter")return;var query=event.target.value.toLowerCase().trim(),count=0;document.querySelectorAll("[data-school-name]").forEach(function(card){var show=card.dataset.schoolName.includes(query);card.classList.toggle("m-hidden",!show);if(show)count++;});document.getElementById("school-no-results").classList.toggle("m-hidden",count>0);});
  } catch(e) { console.error(e); }
})();
})();
